import { useQuery } from "@apollo/client";
import { Box, Spinner } from "grommet";
import { useEffect, useState } from "react";
import FlipMove from "react-flip-move";
import { GET_TOP_FIVE_USERS } from "../queries/user_queries";
import User from "../types/User";
import ErrorMessage from "./Error";
import "./style.css";
import UserRankListingItem from "./UserRankListingItem";

const LeaderBoard = () => {
  const {
    loading,
    error,
    data: userData,
    startPolling,
  } = useQuery(GET_TOP_FIVE_USERS);

  const [users, setUsers] = useState<User[]>([]);
  useEffect(() => {
    startPolling(2000);
  }, []);

  useEffect(() => {
    if (!loading && userData?.getLeaderBoardTippers) {
      setUsers(userData.getLeaderBoardTippers);
    }
  }, [userData, loading]);

  if (error) {
    return <ErrorMessage error={error} />;
  }

  if (!userData?.getLeaderBoardTippers) {
    return (
      <Box align="center" margin={"large"}>
        <Spinner size="large" />
      </Box>
    );
  }

  const orderedUsers = users
    .slice()
    .sort((a: User, b: User) => b.currentTips - a.currentTips);
  const usersList = orderedUsers.map((user: User) => {
    return (
      <UserRankListingItem
        users={orderedUsers}
        key={user.username}
        user={user}
      />
    );
  });
  return (
    <Box
      margin={"large"}
      style={{
        transform: "skewY(3deg)",
      }}
    >
      <Box
        align="center"
        margin="xsmall"
        style={{
          fontFamily: "Orbitron",
          fontSize: 30,
          color: "#eddcff",
        }}
      >
        Leaderboard
      </Box>
      <FlipMove duration={1000} staggerDelayBy={300}>
        {usersList}
      </FlipMove>
    </Box>
  );
};
//https://eventsapi.chaturbate.com/events/crimsonkitten/DrSpeZ1GQCprDFJsFaHiU24i/

export default LeaderBoard;
